import useApi from '../../../api/backendApiContext';
import { useQuery } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../../hooks/useQueryCacheManager';
import useAuth from '../../../auth/authContext';
import { ReactQueryConstants } from '../../../commons/constants';
import { QueryStatus } from '../../../commons/components/QueryStatus';
import { PromptRecentUsage } from '../../types';

export const useFetchedPromptRecentUsages = () => {
  const { growegyAIApi } = useApi();
  const {
    state: { user },
  } = useAuth();
  const queryCacheManager = useQueryCacheManager();
  const queryKey = queryCacheManager.getPromptRecentUsagesCacheKey();
  const query = useQuery(
    queryKey,
    async () => {
      if (!user) {
        return [] as PromptRecentUsage[];
      }
      return growegyAIApi.getPromptRecentUsages(user.userId);
    },
    {
      staleTime: ReactQueryConstants.promptRecentUsagesStaleTime,
      refetchInterval: ReactQueryConstants.promptRecentUsagesRefetchInterval,
      refetchOnWindowFocus: true,
    }
  );
  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="chats"
      failedToLoadText="Something went wrong while loading the prompt recent usages."
    />
  );

  return { query, queryStatusComponent };
};
